var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"main-wrapper","data-navbarbg":"skin6","data-theme":"light","data-layout":"vertical","data-sidebartype":"full","data-boxed-layout":"full"}},[_c('Header-Partial'),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }